var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconControl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 76,
    viewBox: "0 0 75 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 16,
    width: 44,
    height: 44,
    rx: 8,
    fill: "#1E2A10"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1881_1842)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.4961,
    cy: 38,
    r: 13.1094,
    fill: "#AAEF77"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.6083 22.8359H18.7704C17.174 22.8359 15.8799 23.991 15.8799 25.4159V51.3359C15.8799 52.7608 17.174 53.9159 18.7704 53.9159H47.6083C49.2047 53.9159 50.4988 52.7608 50.4988 51.3359V25.4159C50.4988 23.991 49.2047 22.8359 47.6083 22.8359Z",
    fill: "url(#paint0_linear_1881_1842)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0223 26.8066H11.1845C9.58807 26.8066 8.29395 27.9617 8.29395 29.3866V55.3066C8.29395 56.7315 9.58807 57.8866 11.1845 57.8866H40.0223C41.6187 57.8866 42.9128 56.7315 42.9128 55.3066V29.3866C42.9128 27.9617 41.6187 26.8066 40.0223 26.8066Z",
    fill: "url(#paint1_linear_1881_1842)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0223 26.8066H11.1845C9.58807 26.8066 8.29395 27.9617 8.29395 29.3866V55.3066C8.29395 56.7315 9.58807 57.8866 11.1845 57.8866H40.0223C41.6187 57.8866 42.9128 56.7315 42.9128 55.3066V29.3866C42.9128 27.9617 41.6187 26.8066 40.0223 26.8066Z",
    fill: "url(#paint2_linear_1881_1842)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6535 45.2852H10.5537V46.5352H39.6535V45.2852Z",
    fill: "url(#paint3_linear_1881_1842)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6535 49.6836H10.5537V50.9336H39.6535V49.6836Z",
    fill: "url(#paint4_linear_1881_1842)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6535 54.082H10.5537V55.332H39.6535V54.082Z",
    fill: "url(#paint5_linear_1881_1842)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5734 47.4964C25.4515 47.4964 26.1634 46.7845 26.1634 45.9064C26.1634 45.0283 25.4515 44.3164 24.5734 44.3164C23.6953 44.3164 22.9834 45.0283 22.9834 45.9064C22.9834 46.7845 23.6953 47.4964 24.5734 47.4964Z",
    fill: "url(#paint6_linear_1881_1842)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3752 51.8948C33.2533 51.8948 33.9652 51.183 33.9652 50.3048C33.9652 49.4267 33.2533 48.7148 32.3752 48.7148C31.497 48.7148 30.7852 49.4267 30.7852 50.3048C30.7852 51.183 31.497 51.8948 32.3752 51.8948Z",
    fill: "url(#paint7_linear_1881_1842)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.59 56.2933C20.4681 56.2933 21.18 55.5814 21.18 54.7033C21.18 53.8251 20.4681 53.1133 19.59 53.1133C18.7119 53.1133 18 53.8251 18 54.7033C18 55.5814 18.7119 56.2933 19.59 56.2933Z",
    fill: "url(#paint8_linear_1881_1842)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8378 35.1364L22.5078 30.1364C22.3597 30.0593 22.1946 30.0205 22.0277 30.0236C21.8607 30.0267 21.6972 30.0716 21.552 30.1541C21.4068 30.2366 21.2846 30.3542 21.1966 30.4961C21.1085 30.638 21.0574 30.7996 21.0479 30.9664V40.9664C21.0574 41.1331 21.1085 41.2948 21.1966 41.4367C21.2846 41.5785 21.4068 41.6961 21.552 41.7786C21.6972 41.8612 21.8607 41.906 22.0277 41.9091C22.1946 41.9122 22.3597 41.8735 22.5078 41.7964L30.8378 36.7964C30.974 36.7049 31.0855 36.5813 31.1626 36.4366C31.2397 36.2919 31.2801 36.1304 31.2801 35.9664C31.2801 35.8024 31.2397 35.6409 31.1626 35.4961C31.0855 35.3514 30.974 35.2278 30.8378 35.1364Z",
    fill: "#212E12"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8378 35.1364L22.5078 30.1364C22.3597 30.0593 22.1946 30.0205 22.0277 30.0236C21.8607 30.0267 21.6972 30.0716 21.552 30.1541C21.4068 30.2366 21.2846 30.3542 21.1966 30.4961C21.1085 30.638 21.0574 30.7996 21.0479 30.9664V40.9664C21.0574 41.1331 21.1085 41.2948 21.1966 41.4367C21.2846 41.5785 21.4068 41.6961 21.552 41.7786C21.6972 41.8612 21.8607 41.906 22.0277 41.9091C22.1946 41.9122 22.3597 41.8735 22.5078 41.7964L30.8378 36.7964C30.974 36.7049 31.0855 36.5813 31.1626 36.4366C31.2397 36.2919 31.2801 36.1304 31.2801 35.9664C31.2801 35.8024 31.2397 35.6409 31.1626 35.4961C31.0855 35.3514 30.974 35.2278 30.8378 35.1364Z",
    fill: "url(#paint9_linear_1881_1842)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1881_1842",
    x: 0.386719,
    y: 0.890625,
    width: 74.2188,
    height: 74.2188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_1881_1842"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1881_1842",
    x1: 38.702,
    y1: 38.376,
    x2: 54.3456,
    y2: 38.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#325932"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1881_1842",
    x1: 21.701,
    y1: 22.3477,
    x2: 19.0955,
    y2: 46.2162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAEF77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FCF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1881_1842",
    x1: 45.9894,
    y1: 48.1556,
    x2: 31.5142,
    y2: 47.3515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84D349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84D349",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1881_1842",
    x1: 25.1036,
    y1: 45.2852,
    x2: 25.1036,
    y2: 46.5352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DA823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1881_1842",
    x1: 25.1036,
    y1: 49.6836,
    x2: 25.1036,
    y2: 50.9336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DA823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1881_1842",
    x1: 25.1036,
    y1: 54.082,
    x2: 25.1036,
    y2: 55.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DA823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1881_1842",
    x1: 24.5734,
    y1: 44.3164,
    x2: 24.5734,
    y2: 47.4964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80D11B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1881_1842",
    x1: 32.3752,
    y1: 48.7148,
    x2: 32.3752,
    y2: 51.8948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80D11B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1881_1842",
    x1: 19.59,
    y1: 53.1133,
    x2: 19.59,
    y2: 56.2933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80D11B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1881_1842",
    x1: 23.5733,
    y1: 34.9548,
    x2: 27.789,
    y2: 41.5373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80D11B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconControl);
export default __webpack_public_path__ + "static/media/icon-control.6b33ea99847e13fba458cd94a939f999.svg";
export { ForwardRef as ReactComponent };